import React, { useMemo } from "react";
// import logoTag from "../../assets/logo/logoTagThicker.svg";
import logoTag from "../../assets/logo/logoTag.png";

import logoBRCom from "../../assets/logo/logo-brcomerce.svg";

import styles from "./styles.module.scss";
import formatCep from "../../utils/FormatCep";
import { capitalizeFirstLetter } from "../../utils/CapitalizeFirstLetter";
import { integrationToDisplayName } from "../../utils/integrationsToDisplayName";

const TagOwnDelivery = ({
  origin,
  destination,
  tagCode,
  vd,
  shipping,
  tagBarCode,
  dataMatrix,
  senderDefaultName,
  invoiceNumber,
  invoiceKeyBarcode,
  accessKey,
  accessKeyType,
  showNfKey
}) => {
  const invoiceAccessKey = (
    accessKey ||
    shipping?.invoiceAccessKey ||
    ""
  ).replace(/\D/g, "");
  const isDce = accessKeyType === "DCE";
  const showDanfe =
    showNfKey && invoiceAccessKey.length === 44 && !!invoiceKeyBarcode;
  const nfeSerie = showDanfe
    ? String(parseInt(invoiceAccessKey.slice(22, 25), 10))
    : "";
  const nfeNumber = showDanfe
    ? isDce
      ? String(parseInt(invoiceAccessKey.slice(25, 34), 10))
      : invoiceNumber || String(parseInt(invoiceAccessKey.slice(25, 34), 10))
    : "";
  const nfeEmissao = showDanfe
    ? `${invoiceAccessKey.slice(4, 6)}/20${invoiceAccessKey.slice(2, 4)}`
    : "";

  return (
    <div
      className={`${styles.etiqueta1} ${showDanfe ? styles.compact : ""}`}
    >
      <div className={`${styles.head1}`}>
        <img src={logoBRCom} id="img-logo-brcom1" alt="logo empresa" />
        <img src={logoTag} id="img-logo" alt="logo empresa 2" />
      </div>

      <div className={`${styles.body1}`}>
        <div className={styles.tracking1}>
          <img
            src={`data:image/jpeg;base64,${tagBarCode}`}
            alt="Código de barras"
          />
          <span>{tagCode}</span>
        </div>

        <div className={styles.recipientData1}>
          <div>
            {destination?.location?.zone && <span style={{fontWeight: 900, fontSize: '18px', letterSpacing: '1px', border: '1px solid #000', padding: '4px 8px', display: 'inline-block', marginBottom: '8px'}}>{destination.location.zone.split(" ")[0]}</span>}
            <span>{invoiceNumber && `NF: ${invoiceNumber}`}</span>
            <span>
              {" "}
              {(shipping?.orderCode || shipping?.orderNumber) && `Pedido: ${integrationToDisplayName?.includes(shipping?.originCreation) || (shipping?.user?.displayName && shipping?.name) ? shipping?.name : shipping?.orderCode || shipping?.orderNumber}`}
            </span>
            <span>{`Peso: ${shipping?.weight}kg`}</span>
          </div>

          <div>
            <p className={styles.destinary1}>DESTINATÁRIO:</p>
            <div>
              <span>{capitalizeFirstLetter(destination?.name)}</span>
              <span>
                {destination?.street}
                {destination?.number && `, ${destination?.number}`}
                {destination?.complement && ` - ${destination?.complement}`}
              </span>
              <span>{destination?.district}</span>
            </div>
          </div>

          <div>
            <p>
              {formatCep(shipping?.destination?.zip)} {destination?.city} -{" "}
              {destination?.state}
            </p>
            <span>Obs: {shipping?.destination?.observation}</span>
          </div>
        </div>
      </div>

      <div className={styles.recebedor1}>
        <p>
          Assinatura do recebedor: <span></span>
        </p>
        <div>
          <p>
            Documento: <span></span>
          </p>
          <p>
            Data da entrega: <span></span>
          </p>
        </div>
      </div>

      <div className={styles.separation1}>
        <p></p>
      </div>

      <div className={styles.remetente1}>
        <span>
          {`Remetente: ${senderDefaultName
            ? capitalizeFirstLetter(senderDefaultName)
            : capitalizeFirstLetter(origin?.name)
            }`}
        </span>
        <span>
          {origin?.street}
          {origin?.number && `, ${origin?.number}`}
          {origin?.complement && `, ${origin?.complement}`}
        </span>
        <span>{origin?.district}</span>
        <span>
          {formatCep(origin?.zip)} {origin?.city} - {origin?.state}
        </span>
      </div>
      {showDanfe && (
        <div className={styles.danfe}>
          <span className={styles.danfeTitle}>{isDce ? "DACE" : "DANFE"}</span>
          <div className={styles.danfeInfo}>
            <span>
              {isDce ? "DC-e Nº" : "NF DE SAÍDA"}: <strong>{nfeNumber}</strong>
            </span>
            <span>
              SÉRIE: <strong>{nfeSerie}</strong>
            </span>
            <span>
              EMISSÃO: <strong>{nfeEmissao}</strong>
            </span>
          </div>
          <span className={styles.danfeChaveTitle}>CHAVE DE ACESSO</span>
          <img
            src={`data:image/jpeg;base64,${invoiceKeyBarcode}`}
            alt="chave de acesso nfe"
          />
          <span className={styles.danfeChave}>
            {invoiceAccessKey.replace(/(\d{4})(?=\d)/g, "$1 ")}
          </span>
        </div>
      )}
    </div>
  );
};

export { TagOwnDelivery };
